import {useMemo} from 'react';

/*
	Find the time registrations made on the same task/project/idle.
	The matching time registrations are then set to null to reduce the calculation
*/
const findSameTimeRegistrations = (timeRegistrations, timeReg) => {
	return timeRegistrations.reduce((same, t, index) => {
		const tasksMatch = timeReg.node.task && t?.node?.task && timeReg.node.task.id === t.node.task.id;
		const projectsMatch = timeReg.node.project && t?.node?.project && timeReg.node.project.id === t.node.project.id;
		const idleTimesMatch = timeReg.node.idleTime && t?.node?.idleTime && timeReg.node.idleTime.id === t.node.idleTime.id;

		if (tasksMatch || projectsMatch || idleTimesMatch) {
			timeRegistrations[index] = null;
			return [...same, t];
		} else {
			return same;
		}
	}, []);
};

const sortTimeReg = (t1, t2) => {
	const time1 = t1[0].node;
	const time2 = t2[0].node;
	const projectId1 = parseInt(
		time1.project ? time1.project.companyProjectId : time1.task ? time1.task.project.companyProjectId : 111111
	);
	const projectId2 = parseInt(
		time2.project ? time2.project.companyProjectId : time2.task ? time2.task.project.companyProjectId : 111111
	);

	//Same project ?
	if (projectId1 === projectId2) {
		// Same task ?
		const time1TaskName = time1.task ? time1.task.name : '';
		const time2TaskName = time2.task ? time2.task.name : '';

		if (time1TaskName === time2TaskName) {
			//idle times, time off
			const internalTime1 = time1.idleTime ? (!time1.idleTime.isInternalTime ? time1.idleTime.name : '') : '';
			const internalTime2 = time2.idleTime ? (!time2.idleTime.isInternalTime ? time2.idleTime.name : '') : '';
			if (internalTime1 === internalTime2) {
				//idle times, internal time
				const timeOff1 = time1.idleTime ? time1.idleTime.name : '';
				const timeOff2 = time2.idleTime ? time2.idleTime.name : '';
				return timeOff1 > timeOff2;
			}
			return internalTime1 > internalTime2 ? 1 : -1;
		}

		return time1TaskName > time2TaskName ? 1 : -1;
	}
	return projectId1 - projectId2;
};

// All time regs grouped per entity (project, task, idle)
// TODO: Improve this implementation, to avoid modifying the input array.
export function useTimeRegistrationEntityGroups(timeRegistrations) {
	return useMemo(() => {
		// Copy array, as the grouping function will modify it
		const ungroupedTimeRegs = [...timeRegistrations];

		return timeRegistrations
			.filter(t => t?.node)
			.reduce((groups, timeReg) => {
				const group = findSameTimeRegistrations(ungroupedTimeRegs, timeReg);
				return group.length > 0 ? [...groups, group] : groups;
			}, [])
			.sort((t1, t2) => sortTimeReg(t1, t2));
	}, [timeRegistrations]);
}
